import { put, select } from 'redux-saga/effects';
import {
  lockedContentChanged,
  selectLockedContent,
} from 'features/layout/features/content/contentSlice';
import { ContentData, ContentType } from 'features/layout/features/content/types';

type ClearLockedContentOptions =
  { type: ContentType; id: string } | { type: ContentType; ids: string[] };

export function* clearLockedContentSaga(options: ClearLockedContentOptions) {
  const lockedContent: ContentData | null = yield select(selectLockedContent);

  if (!lockedContent || lockedContent.type !== options.type) {
    return;
  }

  if ('ids' in options && !options.ids.includes(lockedContent.id)) {
    return;
  }

  if ('id' in options && options.id !== lockedContent.id) {
    return;
  }

  yield put(lockedContentChanged(null));
}
